<template>
    <TopNav></TopNav>
    <h1>Евро калкулатор</h1>
    <fieldset>
    <legend>Евро калкулатор</legend>
        <label for="bg">BGN:</label> <input type="number" v-model.number="bgn" step="any" @input="onBGNChange" autofocus id="bg"> <label for="bg">лв</label>
        <br>
        <label for="eu">EUR:</label> <input type="number" v-model.number="eur" step="any" @input="onEURChange" id="eu"> <label for="eu">€</label>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "EuroCalculator",
    data() {
        return {
            bgn: 0,
            eur: 0
        }
    },
    components: {
        TopNav
    },
    methods: {
        onBGNChange(e) {
            const lev = e.currentTarget.value;
            this.eur = lev * 0.511292;
        },
        onEURChange(e) {
            const euro = e.currentTarget.value;
            this.bgn = euro * 1.95583;
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
    display: inline-block;
    width: 90px;
}

footer section a {
    margin: 20px;
}
</style>
